<template>
  <div class="flex gap-1 bg-white text-center px-1 py-1 text-primary-0">
    <button @click="onPrev" class="cursor-pointer" v-if="list.length > 1">
      <i class="w-4 block" v-icon:arrow-left></i>
    </button>
    <div v-if="list.length" class="w-1 flex-grow">
      <div class="flex flex-col" :key="`key-${_uid}-${current}`">
        <span class="text-xs font-nunito">{{ list[current].productName }}</span>
        <b class="font-nunito font-bold text-sm">{{ filterPrice(list[current].retailPrice) }}</b>
      </div>
    </div>
    <button @click="onNext" title="Next Price" class="cursor-pointer" v-if="list.length > 1">
      <i class="w-4 block" v-icon:arrow-right></i>
    </button>
  </div>
</template>

<script>
export default {
  name: "VMapCardProduct",
  props: {
    list: {
      type: Array
    }
  },
  data(){
    return {
      current: 0
    }
  },
  methods: {
    filterPrice(str){
      return str.toLocaleString("es-CO", {
        style: 'currency',
        currency: "COP",
        maximumFractionDigits: 0
      })
    },
    onPrev(){
      if(this.current > 0){
        this.current --
      }else {
        this.current = this.list.length - 1;
      }
    },
    onNext(){
      if(this.current < this.list.length - 1){
        this.current ++
      }else {
        this.current = 0;
      }
    }
  }

}
</script>

<style lang="scss" scoped></style>